import { render, staticRenderFns } from "./DashboardsListing.vue?vue&type=template&id=e179279c&scoped=true&"
import script from "./DashboardsListing.vue?vue&type=script&lang=js&"
export * from "./DashboardsListing.vue?vue&type=script&lang=js&"
import style0 from "./DashboardsListing.vue?vue&type=style&index=0&id=e179279c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e179279c",
  null
  
)

export default component.exports